// src/i18n.ts
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n.use(initReactI18next).init({
  resources: {
    tr: {
      translation: {
        home: "Anasayfa",
        products: "Ürünlerimiz",
        boats: "Tekne ve Yatlar",
        accessories: "Aksesuarlar",
        engines: "Motorlar",
        gallery: "Galeri",
        about: "Hakkımızda",
        news: "Haberler",
        contact: "İletişim",
        slogan: "Hayallerini erteleme, hayallerine yelken aç",
        lang: "Dil",
        anchor: "Elektrikli Motor & Sanal Çapa",
        second: "İkinci El",



        aboutSection: {
          title: "BİZ KİMİZ?",
          p1: "Ayvalık Marin, Ege’nin incisi Ayvalık’ta, deniz tutkunlarının hayallerini gerçeğe dönüştürmek amacıyla kurulmuştur. 30 yıllık tecrübenin getirdiği bilgi birikimiyle, en iyi hizmet, kalite ve sağlamlık ilkesi doğrultusunda faaliyet göstermektedir.",
          p2: "Modern üretim teknikleri, yüksek kaliteli malzeme seçimi ve usta işçilikle şekillenen teknelerimiz; yalnızca bir taşıma aracı değil, özgün ve konforlu bir yaşam tarzı sunar. Kurumsal ve bireysel çözümlerimizle, denizde geçireceğiniz zamanı daha güvenli, keyifli ve konforlu hale getirmeyi hedefliyoruz.",
          p3a: "Ayvalık Marin, kurulduğu günden bu yana müşteri memnuniyetini ön planda tutarak, Avrupa standartlarında",
          p3b: "belgeli üretim yapmakta ve her projeye özel çözümler sunmaktadır.",
          p4: "Profesyonel kadromuz; imalat, bakım, onarım, motor montajı, elektrik ve sıhhi tesisat dahil olmak üzere tüm süreçleri A’dan Z’ye titizlikle yürütmektedir. Zamanında ve yüksek kaliteyle tamamlanan projelerimizle, “Güvenilir Hizmet ve Yüksek Kalite” anlayışını benimseyerek, sektörde lider firmalardan biri olma yolunda emin adımlarla ilerliyoruz.",
          slogan:
            "Ayvalık Marin — Denizin Eşsiz Maviliğinde, Hayallerinizin Yol Arkadaşı.",
        },
        hero: {
          mavi: "Denizin Eşsiz",
          maviliğinde: "Maviliğinde",
          yolArkadaşı: "Hayallerinizin Yol Arkadaşı.",
          hayal: "Hayallerini Erteleme, Hayallerine Yelken Aç.",
          tasarim: "Ayvalığ’ın Ruhunu Taşıyan Özel Tasarımlar.",
        },
      },
    },
    en: {
      translation: {
        home: "Home",
        products: "Our Products",
        boats: "Boats and Yachts",
        accessories: "Accessories",
        engines: "Engines",
        gallery: "Gallery",
        about: "About Us",
        news: "News",
        contact: "Contact",
        slogan: "Don't postpone your dreams, sail to them",
        lang: "Language",
        anchor: "Spot-Lock",
        second: "Used",

        aboutSection: {
          title: "WHO ARE WE?",
          p1: "Ayvalık Marin was established in Ayvalık, the pearl of the Aegean, with the aim of turning the dreams of sea lovers into reality. With 30 years of experience, it operates in line with the principles of best service, quality, and durability.",
          p2: "Our boats, shaped with modern production techniques, high-quality materials, and master craftsmanship, offer not just transportation but a unique and comfortable lifestyle. We aim to make your time at sea safer, more enjoyable, and more comfortable with our corporate and individual solutions.",
          p3a: "Since its establishment, Ayvalık Marin has prioritized customer satisfaction and produces in compliance with European standards, holding",
          p3b: "certification and providing custom solutions for every project.",
          p4: "Our professional team meticulously manages all processes from A to Z including manufacturing, maintenance, repair, engine installation, electrical and sanitary systems. With projects completed on time and with high quality, we embrace the principle of 'Reliable Service and High Quality' and are advancing confidently toward becoming one of the leading companies in the industry.",
          slogan:
            "Ayvalık Marin — Your Companion on the Blue Dream of the Sea.",
        },
        hero: {
          mavi: "In the Unique",
          maviliğinde: "Blue of the Sea",
          yolArkadaşı: "Your Companion on the Journey of Dreams.",
          hayal: "Don't Postpone Your Dreams, Set Sail for Them.",
          tasarim: "Special Designs That Reflect the Soul of Ayvalık.",
        },
      },
    },
  },
  lng: "tr",
  fallbackLng: "tr",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
